var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-action",class:{ 'sticky-action': _vm.disabled ? true : _vm.actionSticked }},[_vm._t("default",null,{"stickAction":_vm.stickAction,"unstickAction":_vm.unStickAction})],2)}
var staticRenderFns = []

export { render, staticRenderFns }